export const OFFERS_STORE_ID = 'offers';
